document.addEventListener('DOMContentLoaded', () => {
  const stageEl = document.getElementById('GiveawayStage');
  const wheel = document.getElementById('GiveawayWheel');
  const wheelWrap = document.getElementById('GiveawayWheelWrap');
  const pointerEl = document.getElementById('GiveawayPointer');
  const resultEl = document.getElementById('GiveawayResult');
  const dataEl = document.getElementById('GiveawaySlices');
  const celebration = document.getElementById('GiveawayCelebration');
  const celebrationText = document.getElementById('GiveawayCelebrationText');
  const celebrationImg = document.getElementById('GiveawayCelebrationImage');
  const introHint = document.getElementById('GiveawayIntroHint');
  const emailGate = document.getElementById('GiveawayEmailGate');
  const emailGateForm = document.getElementById('GiveawayEmailGateForm');
  const emailGateInput = document.getElementById('GiveawayEmailGateInput');
  const emailGateField = document.getElementById('GiveawayEmailGateField');
  const statusEl = document.getElementById('GiveawayStatus');
  const statusEmailEl = document.getElementById('GiveawayStatusEmail');
  const statusResetBtn = document.getElementById('GiveawayStatusReset');
  const turnstileEl = document.getElementById('GiveawayTurnstile');
  const legendEl = document.getElementById('GiveawayLegend');

  if (!wheel || !wheelWrap || !resultEl || !dataEl) return;

  // ---- Scroll-Sperre fuer Vollbild-Overlays ---------------------------------
  // body.style.overflow = 'hidden' allein reicht auf iOS Safari NICHT: dort
  // haengt das Scrollen am Viewport, nicht am <body>, die Sperre wird schlicht
  // ignoriert. Beobachtet 2026-08-26 im Video (Preis-Popup offen, Wischen
  // scrollt die Seite dahinter weiter, das Overlay wandert mit und Safari
  // blendet dabei seine Leisten ein/aus).
  //
  // Zuverlaessig ist nur: den Body wirklich aus dem Fluss nehmen
  // (position:fixed) und die Scrollposition selbst merken bzw. beim Entsperren
  // exakt wiederherstellen - ohne das top:-Ypx springt die Seite beim Oeffnen
  // nach ganz oben.
  //
  // Zaehler statt Boolean, damit sich zwei gleichzeitig offene Overlays
  // (Gewinn-Foto kann ueber einem Tuer-Popup erscheinen) nicht gegenseitig zu
  // frueh entsperren.
  let scrollLockCount = 0;
  let scrollLockY = 0;
  function lockScroll() {
    if (scrollLockCount++ > 0) return;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    const s = document.body.style;
    s.position = 'fixed';
    s.top = `-${scrollLockY}px`;
    s.left = '0';
    s.right = '0';
    s.width = '100%';
    s.overflow = 'hidden';
  }
  function unlockScroll() {
    if (scrollLockCount === 0) return;
    if (--scrollLockCount > 0) return;
    const s = document.body.style;
    s.position = '';
    s.top = '';
    s.left = '';
    s.right = '';
    s.width = '';
    s.overflow = '';
    // 'instant' statt des moeglichen smooth-Scrollings - der Sprung zurueck
    // soll unsichtbar sein, nicht als Animation wahrgenommen werden.
    window.scrollTo({ top: scrollLockY, behavior: 'instant' });
  }

  // Rein visuelle Zuordnung Preis-ID -> Rad-Segment-Paar, siehe Kommentar in
  // violex-giveaway.liquid. Reihenfolge im Array = Position auf dem Rad.
  // Die eigentliche Preis-ENTSCHEIDUNG kommt vom Server (spinEndpoint) -
  // dieses Array sagt dem Theme nur noch, auf welches Segment es das Rad
  // animieren soll und wie der Preis heisst, falls die Antwort keine eigene
  // Beschriftung mitliefert.
  const prizes = JSON.parse(dataEl.textContent);
  // Winkelbreite eines einzelnen Rad-Segments - dieselbe Formel wie in
  // animateToSlice(), aber schon hier verfuegbar, weil animateSpin() sie
  // braucht, um zu erkennen, wann waehrend der Drehung eine Farbgrenze den
  // fest stehenden Zeiger passiert (siehe pointerTick unten).
  const wheelSliceSize = 360 / (prizes.length * 2);
  const resultPrefix = wheelWrap.dataset.resultPrefix || '';
  const wheelDisabled = wheelWrap.dataset.wheelDisabled === 'true';
  const spinEndpoint = wheelWrap.dataset.spinEndpoint || '';
  const limitReachedMessage = wheelWrap.dataset.limitReachedMessage || "You've used all your spins for today.";
  const budgetReachedMessage = wheelWrap.dataset.budgetReachedMessage || "Today's spins are all used up.";
  const pendingVerificationMessage = wheelWrap.dataset.pendingVerificationMessage || '';
  const errorMessage = wheelWrap.dataset.errorMessage || 'Something went wrong. Please try again.';
  const turnstileSiteKey = wheelWrap.dataset.turnstileSiteKey || '';
  const prizesEndpoint = wheelWrap.dataset.prizesEndpoint || '';

  // Legende (Punkt+Name unter dem Rad) dynamisch aus der echten Admin-App-
  // Preiskonfiguration befuellen, statt aus den Theme-Settings oben - die
  // waren bisher von Hand mit der Admin-App synchron zu halten (siehe
  // GiveawaySlices, das bleibt fuers Rad-Segment-Mapping unveraendert). Bei
  // einem Fetch-Fehler bleibt der aus den Theme-Settings vorgerenderte
  // Startzustand einfach stehen (kein Absturz, keine leere Liste).
  function renderLegend(livePrizes) {
    if (!legendEl) return;
    legendEl.innerHTML = '';
    const swatchClasses = ['violex-giveaway__swatch--1', 'violex-giveaway__swatch--2', 'violex-giveaway__swatch--3'];
    livePrizes.forEach((prize, index) => {
      const li = document.createElement('li');
      li.dataset.prizeId = prize.id;
      const swatch = document.createElement('span');
      swatch.className = `violex-giveaway__swatch ${swatchClasses[index % swatchClasses.length]}`;
      const label = document.createElement('span');
      label.className = 'violex-giveaway__legend-label';
      label.textContent = prize.label;
      li.append(swatch, label);
      legendEl.appendChild(li);
    });
    // "Nichts" ist kein echter Preis in der Admin-App-Liste (siehe
    // DEFAULT_SETTINGS.prizes in giveawaySpin.js), gehoert aber immer als
    // letztes, eigenfarbiges Segment in die Legende.
    const nothingLi = document.createElement('li');
    nothingLi.dataset.prizeId = 'nothing';
    const nothingSwatch = document.createElement('span');
    nothingSwatch.className = 'violex-giveaway__swatch violex-giveaway__swatch--4';
    const nothingLabel = document.createElement('span');
    nothingLabel.className = 'violex-giveaway__legend-label';
    nothingLabel.textContent = 'Nichts';
    nothingLi.append(nothingSwatch, nothingLabel);
    legendEl.appendChild(nothingLi);
  }

  if (prizesEndpoint) {
    fetch(prizesEndpoint)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data && data.ok && Array.isArray(data.prizes)) renderLegend(data.prizes);
      })
      .catch(() => {
        // Stiller Fallback - Startzustand aus den Theme-Settings bleibt sichtbar.
      });
  }

  // E-Mail-Freischaltung: rein clientseitiges UX-Gate (wer darf überhaupt
  // versuchen zu drehen), einmal hinterlegt bleibt es dauerhaft freigeschaltet.
  // Die eigentlichen Limits (Tages-Limit pro E-Mail, globales Tages-Budget,
  // Wochen-Quote pro Preis) prüft ausschliesslich der Server bei jedem Spin -
  // hier gibt es keine eigene Zählung mehr (siehe violex-elite-api).
  const UNLOCK_KEY = 'violexGiveawayUnlock_v1';
  // Rein kosmetisch (letztes Ergebnis nach Reload weiter anzeigen) - hat
  // keinerlei Einfluss auf Limits, die kommen ausschliesslich vom Server.
  const LAST_RESULT_KEY = 'violexGiveawayLastResult_v1';
  // Rein kosmetisch (Spins-Anzeige/Countdown ohne auf den naechsten Spin zu
  // warten) - ebenfalls keine Sicherheitsrelevanz, siehe oben. Der Server
  // prueft bei jedem Spin ohnehin nochmal alles neu.
  const LAST_STATUS_KEY = 'violexGiveawayLastStatus_v1';

  function getUnlockedEmail() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(UNLOCK_KEY) || 'null');
      return (stored && stored.email) || null;
    } catch (e) {
      return null;
    }
  }

  function setUnlockedEmail(email) {
    try {
      window.localStorage.setItem(UNLOCK_KEY, JSON.stringify({ email: email }));
    } catch (e) {
      // localStorage nicht verfuegbar - Rad bleibt dann bei jedem Seitenaufruf gesperrt.
    }
  }

  function clearUnlock() {
    try {
      window.localStorage.removeItem(UNLOCK_KEY);
      window.localStorage.removeItem(LAST_RESULT_KEY);
      window.localStorage.removeItem(LAST_STATUS_KEY);
    } catch (e) {
      // s.o.
    }
  }

  function saveLastResult(text) {
    try {
      window.localStorage.setItem(LAST_RESULT_KEY, JSON.stringify({ text: text, at: Date.now() }));
    } catch (e) {
      // s.o.
    }
  }

  function getLastResult() {
    try {
      return JSON.parse(window.localStorage.getItem(LAST_RESULT_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function saveLastStatus(status) {
    try {
      window.localStorage.setItem(LAST_STATUS_KEY, JSON.stringify(status));
    } catch (e) {
      // s.o.
    }
  }

  function getLastStatus() {
    try {
      return JSON.parse(window.localStorage.getItem(LAST_STATUS_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  // z.B. "te***@mail.com" - rein kosmetisch, nicht als Sicherheitsmassnahme
  // gedacht (die E-Mail steht ohnehin schon im Klartext im localStorage
  // dieses Browsers), sondern damit ein Bildschirm-Vorbeigehender nicht die
  // volle Adresse mitlesen kann.
  function maskEmail(email) {
    const at = email.indexOf('@');
    if (at <= 0) return email;
    const name = email.slice(0, at);
    const domain = email.slice(at);
    const visible = name.slice(0, Math.min(2, name.length));
    return `${visible}${'*'.repeat(Math.max(3, name.length - visible.length))}${domain}`;
  }

  const isLocalHost = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);

  let currentRotation = 0;
  let spinning = false;
  let turnstileToken = null;
  let turnstileWidgetId = null;

  function updateAvailabilityUI() {
    // Quoten/Ausverkauft-Status kommt inzwischen ausschliesslich vom Server
    // (Antwort auf den Spin), es gibt hier nichts mehr vorab anzuzeigen -
    // Funktion bleibt als Hook fuer setDisabled() bestehen.
  }

  function setDisabled(disabled) {
    wheelWrap.classList.toggle('is-disabled', disabled);
    wheelWrap.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    if (!disabled) {
      updateAvailabilityUI();
    }
  }

  /**
   * Zeigt (maskierte) E-Mail + "Nicht du?"-Link unterhalb des Rads, sobald
   * freigeschaltet. status kommt aus der letzten Spin-Antwort (oder aus
   * LAST_STATUS_KEY nach einem Reload) - rein informativ, der Server bleibt
   * in jedem Fall die einzige Quelle der Wahrheit fuer Limits. Der frühere
   * "X von Y Spins übrig"-Text (samt Live-Countdown bis zum Reset) ist raus
   * (Vorgabe Igor, 2026-08-26: "entferne das mit dem wie viel Spins man noch
   * hat") - stattdessen verblasst jetzt das Rad selbst mit Schloss-Overlay,
   * siehe setLimitReached() gleich unten.
   *
   * deferLimit=true (nur beim erfolgreichen Spin, siehe spin() unten): das
   * Ausgrauen von Rad+Zeiger wird NICHT sofort gesetzt, sondern nur gemerkt
   * (pendingLimitReached) - die Antwort kommt schon VOR der 10s-Dreh-
   * Animation an, das Ausgrauen soll aber erst danach sichtbar werden
   * (Vorgabe Igor, 2026-08-26: "Zeiger auch ausgrauen wie das Rad, aber
   * erst wenn es zu Ende gespinnt hat"). applyPendingLimitReached() wendet
   * es im onDone-Callback von animateToSlice an.
   */
  function renderStatus(status, deferLimit) {
    if (!statusEl) return;
    const email = getUnlockedEmail();
    if (!email) {
      statusEl.hidden = true;
      setLimitReached(false);
      return;
    }

    statusEl.hidden = false;
    if (statusEmailEl) statusEmailEl.textContent = maskEmail(email);

    const remaining = status && typeof status.spinsPerDay === 'number'
      ? Math.max(0, status.spinsRemainingToday || 0)
      : null;
    const reached = remaining !== null && remaining <= 0;
    if (deferLimit) {
      pendingLimitReached = reached;
    } else {
      setLimitReached(reached);
    }
  }

  // Rad verblasst + Schloss-Bild davor, sobald fuer heute keine Spins mehr
  // uebrig sind (Vorgabe Igor, 2026-08-26: "wenn man fertig gedreht hat,
  // verblasst das Glücksrad, Schloss davor" - Zeiger zieht per CSS-Sibling-
  // Selektor automatisch mit, siehe .is-limit-reached ~ .pointer in
  // violex-giveaway.css) - komplett unabhaengig vom admin-gesteuerten
  // "wheel_disabled" (is-wheel-disabled oben), rein clientseitig anhand der
  // letzten Server-Antwort.
  let pendingLimitReached = null;
  function setLimitReached(reached) {
    if (wheelWrap) wheelWrap.classList.toggle('is-limit-reached', reached);
  }
  function applyPendingLimitReached() {
    if (pendingLimitReached !== null) {
      setLimitReached(pendingLimitReached);
      pendingLimitReached = null;
    }
  }

  function findPrizeIndex(prizeId) {
    const index = prizes.findIndex((p) => p.id === prizeId);
    return index === -1 ? prizes.length - 1 : index; // Fallback: letztes Segment ("Nichts")
  }

  // Nur fuer lokales Design-Testing: taeuscht eine Server-Antwort vor (mit
  // zufaelligem Preis aus den sichtbaren Rad-Segmenten), damit die komplette
  // Spin-/Gewinn-Animation ohne den echten Worker (violex-elite-api, aktuell
  // deaktiviert) angeschaut werden kann. spinsRemainingToday zaehlt dabei
  // pro Browser-Tab wirklich runter (statt fest bei 2 zu bleiben) - sonst
  // liesse sich das Tageslimit (verblasstes Rad + Schloss, siehe
  // setLimitReached()) lokal nie auslösen/anschauen.
  const MOCK_SPINS_PER_DAY = 3;
  let mockSpinsUsedToday = 0;
  function mockSpinResponse() {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        const chosen = prizes[Math.floor(Math.random() * prizes.length)];
        mockSpinsUsedToday = Math.min(MOCK_SPINS_PER_DAY, mockSpinsUsedToday + 1);
        resolve({
          ok: true,
          prizeId: chosen.id,
          prizeLabel: chosen.label,
          spinsPerDay: MOCK_SPINS_PER_DAY,
          spinsRemainingToday: MOCK_SPINS_PER_DAY - mockSpinsUsedToday,
        });
      }, 500);
    });
  }

  async function requestSpin(email) {
    if (isLocalHost) return mockSpinResponse();

    const payload = { email: email };
    // Nur gesetzt, wenn ein Turnstile-Site-Key konfiguriert ist (siehe
    // initTurnstile) - ohne Konfiguration bleibt turnstileToken einfach weg,
    // der Worker verlangt ihn dann auch nicht (siehe verifyTurnstile dort).
    if (turnstileToken) payload.turnstileToken = turnstileToken;

    const res = await fetch(spinEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    // Ein einmal verwendetes Turnstile-Token ist danach ungueltig - fuer den
    // naechsten Spin brauchen wir ein frisches (siehe resetTurnstile unten).
    resetTurnstile();
    return res.json();
  }

  function spin() {
    const email = getUnlockedEmail();
    if (wheelDisabled || spinning || !email) return;
    if (!spinEndpoint) {
      resultEl.textContent = errorMessage;
      return;
    }

    spinning = true;
    if (stageEl) stageEl.classList.add('is-spinning');
    setDisabled(true);
    resultEl.textContent = '';

    resultEl.textContent = wheelWrap.dataset.spinningText || 'Spinning…';

    requestSpin(email)
      .then((data) => {
        // spinsPerDay/spinsRemainingToday/resetAt kommen bei jeder Antwort
        // (Erfolg wie Ablehnung) vom Server - Status-Anzeige unabhaengig vom
        // Ausgang aktualisieren und fuer den naechsten Seitenaufruf merken.
        // Bei Erfolg (data.ok) noch VOR der Dreh-Animation, das Ausgrauen
        // von Rad+Zeiger soll aber erst danach sichtbar werden -> deferLimit
        // true, angewendet unten im onDone-Callback. Bei Ablehnung (Limit
        // schon erreicht, gar keine Animation) sofort setzen.
        if (data && typeof data.spinsPerDay === 'number') {
          saveLastStatus(data);
          renderStatus(data, !!(data && data.ok));
        }

        if (!data || !data.ok) {
          spinning = false;
          if (stageEl) stageEl.classList.remove('is-spinning');
          setDisabled(false);
          let message;
          if (data && data.code === 'limit_reached') {
            message = limitReachedMessage;
          } else if (data && data.code === 'budget_reached') {
            message = budgetReachedMessage;
          } else {
            message = (data && data.message) || errorMessage;
          }
          resultEl.textContent = message;
          saveLastResult(message);
          return;
        }

        const chosenIndex = findPrizeIndex(data.prizeId);
        const chosen = prizes[chosenIndex];
        const label = data.prizeLabel || chosen.label;

        animateToSlice(chosenIndex, () => {
          let resultText = chosen.resultText || (resultPrefix ? `${resultPrefix} ${label}` : label);
          if (data.pendingVerification && pendingVerificationMessage) {
            resultText = `${resultText} ${pendingVerificationMessage}`;
          }
          resultEl.textContent = resultText;
          saveLastResult(resultText);
          spinning = false;
          if (stageEl) stageEl.classList.remove('is-spinning');
          setDisabled(false);
          // Erst jetzt, nach der 10s-Dreh-Animation, das ggf. oben per
          // renderStatus(data, true) gemerkte Ausgrauen anwenden.
          applyPendingLimitReached();

          // Zeigt die Fullscreen-Celebration fuer jedes Segment mit eigenem
          // Foto - inzwischen auch "Nichts" (Vorgabe Igor, 2026-08-26: "Bild
          // wenn man nicht gewinnt, gleich wie die anderen"), nicht mehr nur
          // "grand"-Preise.
          if (chosen.image && celebration && celebrationText) {
            showCelebration(resultText, chosen.image);
          }
        });
      })
      .catch(() => {
        spinning = false;
        if (stageEl) stageEl.classList.remove('is-spinning');
        setDisabled(false);
        resultEl.textContent = errorMessage;
      });
  }

  // Rotiert das Rad so, dass es zufaellig irgendwo innerhalb des Segment-Paars
  // von chosenIndex zum Stillstand kommt, und ruft danach onDone() auf.
  function animateToSlice(chosenIndex, onDone) {
    const sliceSize = wheelSliceSize;
    const slicePositions = [chosenIndex, chosenIndex + prizes.length];
    const targetSlice = slicePositions[Math.floor(Math.random() * slicePositions.length)];
    const segmentStartAngle = targetSlice * sliceSize;
    const targetAngle = segmentStartAngle + Math.random() * sliceSize;

    const targetMod = (360 - targetAngle) % 360;
    const currentMod = ((currentRotation % 360) + 360) % 360;
    let delta = targetMod - currentMod;
    if (delta < 0) delta += 360;

    const extraSpins = 22;
    const totalDelta = delta + extraSpins * 360;
    const startRotation = currentRotation;
    currentRotation += totalDelta;

    animateSpin(startRotation, totalDelta, onDone);
  }

  // Bei einem "grand" Gewinn dimmt die ganze Seite kurz ab und zeigt danach
  // das Gewinn-Foto (Polo/Card, je nach chosen.image aus GiveawaySlices)
  // fullscreen - verschwindet nach 15s von selbst wieder (Vorgabe Igor,
  // 2026-08-26: "Seite verblasst, dann Bild fullscreen bis an den Rand,
  // im schlimmsten Fall scrollen"; Anzeigedauer am selben Tag von 5s auf
  // 15s erhoeht. Ersetzt den reinen Gewinntext von der Vorgabe 2026-08-27
  // davor - die Fotos tragen den "You won"-Text bereits eingebrannt).
  let celebrationTimeout = null;
  function showCelebration(resultText, imageSrc) {
    const celebrationTextEl = celebration.querySelector('.violex-giveaway__celebration-text');
    if (celebrationTimeout) window.clearTimeout(celebrationTimeout);

    const hasImage = Boolean(imageSrc && celebrationImg);
    celebration.classList.toggle('violex-giveaway__celebration--image', hasImage);
    if (hasImage) {
      celebrationImg.src = imageSrc;
      celebrationImg.alt = resultText || '';
    }
    celebrationText.textContent = resultText;
    // Nur sperren, wenn das Overlay nicht ohnehin schon offen ist (zwei Spins
    // kurz hintereinander) - sonst zaehlt lockScroll doppelt hoch und der
    // spaetere Timeout entsperrt nie wieder.
    const celebrationWasVisible = celebration.classList.contains('is-visible');
    celebration.classList.add('is-visible');
    celebration.setAttribute('aria-hidden', 'false');
    if (!celebrationWasVisible) lockScroll();
    if (celebrationTextEl) celebrationTextEl.classList.add('is-shown');
    // Bei Bild-Variante von oben statt vertikal zentriert zeigen (siehe CSS)
    // - scrollt der Ausschnitt beim Oeffnen trotzdem, faengt er wieder oben an.
    celebration.scrollTop = 0;

    celebrationTimeout = window.setTimeout(() => {
      celebration.classList.remove('is-visible');
      celebration.setAttribute('aria-hidden', 'true');
      if (celebrationTextEl) celebrationTextEl.classList.remove('is-shown');
      unlockScroll();
      celebrationTimeout = null;
    }, 15000);
  }

  // Kurzer Hinweis-Popup direkt nach dem Freischalten/Login (Vorgabe Igor,
  // 2026-08-26: "Info-Box, Screen verblasst, sagt Schrank/Portemonnaie
  // antippen, verschwindet nach 5s selber") - ausgeloest ueber
  // refreshGateVisibility() weiter unten, sobald der Zustand von gesperrt
  // auf freigeschaltet wechselt (frischer Login wie auch Wiederkehren mit
  // bereits gemerkter E-Mail).
  let introHintTimeout = null;
  function showIntroHint() {
    if (!introHint) return;
    if (introHintTimeout) window.clearTimeout(introHintTimeout);
    introHint.classList.add('is-visible');
    introHint.setAttribute('aria-hidden', 'false');
    introHintTimeout = window.setTimeout(() => {
      introHint.classList.remove('is-visible');
      introHint.setAttribute('aria-hidden', 'true');
      introHintTimeout = null;
    }, 5000);
  }
  if (introHint) {
    introHint.addEventListener('click', () => {
      if (introHintTimeout) {
        window.clearTimeout(introHintTimeout);
        introHintTimeout = null;
      }
      introHint.classList.remove('is-visible');
      introHint.setAttribute('aria-hidden', 'true');
    });
  }

  // 10s durchgehend, von Anfang an schnell und mit der Zeit kontinuierlich
  // langsamer werdend bis zum Stillstand (Vorgabe Igor, 2026-08-26: "10
  // Sekunden, am Anfang schnell und dann langsamer mit der Zeit bis zum
  // Stillstand") - eine einzige Ease-out-Kurve statt getrennter Konstant-/
  // Brems-Phase, per requestAnimationFrame statt CSS-Transition, damit
  // pointerTick() bei jedem Frame den exakten aktuellen Winkel kennt.
  function animateSpin(startRotation, totalDelta, onDone) {
    const TOTAL_MS = 10000;
    const startTime = performance.now();
    // Wie viele Segmentgrenzen bis zur Startrotation bereits "passiert" waeren
    // - Referenzpunkt fuer pointerTick(), damit gleich die erste ueberquerte
    // Grenze waehrend dieses Spins erkannt wird (nicht erst die naechste).
    let lastBoundary = Math.floor(startRotation / wheelSliceSize);

    function pointerTick(currentRotation) {
      const boundary = Math.floor(currentRotation / wheelSliceSize);
      if (boundary === lastBoundary) return;
      lastBoundary = boundary;
      if (!pointerEl) return;
      // Animation neu antriggern, falls sie gerade noch laeuft (z.B. bei
      // hoher Geschwindigkeit mehrere Grenzen kurz hintereinander) - Klasse
      // entfernen, Reflow erzwingen, wieder hinzufuegen.
      pointerEl.classList.remove('is-ticking');
      void pointerEl.offsetWidth;
      pointerEl.classList.add('is-ticking');
    }

    // Kubisches Ease-out: Geschwindigkeit ist bei t=0 am hoechsten und faellt
    // stetig auf 0 bei t=1 - genau das "schnell -> immer langsamer -> Stopp".
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function frame(now) {
      const elapsed = now - startTime;
      const t = Math.min(1, elapsed / TOTAL_MS);
      const angle = totalDelta * easeOutCubic(t);

      wheel.style.transform = `rotate(${startRotation + angle}deg)`;
      pointerTick(startRotation + angle);

      if (elapsed < TOTAL_MS) {
        requestAnimationFrame(frame);
      } else {
        onDone();
      }
    }

    requestAnimationFrame(frame);
  }

  // E-Mail-Freischaltung: Gate ausblenden + Rad/Zeiger/Foto "aufwecken",
  // sobald lokal schon eine E-Mail hinterlegt ist (siehe UNLOCK_KEY oben).
  // Laeuft rein ueber die Klasse "is-unlocked" auf der Buehne (nicht mehr
  // per [hidden]-Attribut auf dem Gate selbst), damit CSS den Uebergang
  // (Fade/Blur-Aufloesung, siehe violex-giveaway.css) animieren kann - siehe
  // Login-Redesign 2026-08-26. Ohne Gate (wheel_disabled) passiert hier
  // nichts, die Klasse existiert dann gar nicht in der CSS.
  // Zeigt zusaetzlich den Hinweis-Popup (showIntroHint()), aber nur beim
  // Wechsel von gesperrt -> freigeschaltet (wasUnlocked-Flag) - nicht bei
  // jedem erneuten Aufruf (z.B. "Not you?"-Reset laeuft auch hier durch,
  // landet dann aber wieder im gesperrten Zustand).
  let wasUnlocked = false;
  function refreshGateVisibility() {
    const unlocked = !!getUnlockedEmail();
    if (stageEl) stageEl.classList.toggle('is-unlocked', unlocked);
    renderStatus(getLastStatus());
    if (unlocked && !wasUnlocked) showIntroHint();
    wasUnlocked = unlocked;
  }
  refreshGateVisibility();

  // Nur fuer lokales Design-Testing (theme dev auf 127.0.0.1/localhost):
  // Skip-Button UNTERHALB des Rads (nicht in den ohnehin engen Kreis mit
  // Titel/Input/Unlock/Checkbox gepackt, sonst wird er von der zentrierten
  // Flexbox aus der sichtbaren Kreisflaeche rausgedrueckt). Erscheint nie auf
  // der echten Domain, da rein per Hostname-Check.
  if (wheelWrap && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    const skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.textContent = 'Skip (local design preview)';
    skipBtn.style.cssText = 'display:block;margin:14px auto 0;background:#f3d26b;border:none;border-radius:8px;color:#0f0316;opacity:.85;padding:8px 16px;cursor:pointer;font-size:13px;font-family:Georgia,serif;position:relative;z-index:5;';
    skipBtn.addEventListener('click', () => {
      setUnlockedEmail('design-preview@local.test');
      refreshGateVisibility();
    });
    wheelWrap.insertAdjacentElement('afterend', skipBtn);
  }

  // Letztes Ergebnis nach einem Reload weiter anzeigen (rein kosmetisch, s.o.).
  if (getUnlockedEmail()) {
    const lastResult = getLastResult();
    if (lastResult && lastResult.text) resultEl.textContent = lastResult.text;
  }

  if (statusResetBtn) {
    statusResetBtn.addEventListener('click', () => {
      clearUnlock();
      refreshGateVisibility();
      resultEl.textContent = '';
      if (emailGateInput) {
        emailGateInput.value = '';
        emailGateInput.focus();
      }
    });
  }

  // Mehrere offene Tabs auf derselben Seite synchron halten: entsperrt man
  // das Rad in Tab A, soll Tab B das beim naechsten Blick dorthin auch
  // sofort zeigen, ohne Reload. 'storage' feuert nur in ANDEREN Tabs
  // desselben Origins, nie im Tab, der die Aenderung selbst ausgeloest hat.
  window.addEventListener('storage', (event) => {
    if (event.key === UNLOCK_KEY || event.key === LAST_STATUS_KEY || event.key === null) {
      refreshGateVisibility();
    }
  });

  // Kurzes Wackeln bei ungueltiger Eingabe statt der nativen Browser-
  // Validierungs-Blase (Login-Redesign 2026-08-26) - Klasse entfernen,
  // Reflow erzwingen, wieder hinzufuegen, damit es bei wiederholtem
  // Fehlversuch jedes Mal neu abspielt.
  function shakeGateEl(el) {
    if (!el) return;
    el.classList.remove('is-shaking');
    void el.offsetWidth;
    el.classList.add('is-shaking');
  }

  if (emailGateForm) {
    emailGateForm.addEventListener('click', (event) => event.stopPropagation());
    emailGateForm.addEventListener('submit', (event) => {
      event.preventDefault();
      if (stageEl && (stageEl.classList.contains('is-unlocking') || stageEl.classList.contains('is-unlocked'))) return;

      const email = emailGateInput ? emailGateInput.value.trim() : '';
      const emailValid = email.length > 2 && email.indexOf('@') > 0;
      let ok = true;

      if (emailGateField) {
        emailGateField.classList.toggle('has-error', !emailValid);
      }
      if (!emailValid) {
        shakeGateEl(emailGateField);
        ok = false;
      }

      // Alle Pflicht-Checkboxen (data-required="true", siehe
      // violex-giveaway.liquid: Alter/Wohnsitz + Teilnahmebedingungen) muessen
      // angehakt sein - die freiwillige Marketing-Box (3.) hat kein
      // data-required und wird hier bewusst nicht geprueft.
      const requiredConsents = emailGateForm.querySelectorAll('.violex-giveaway__email-gate-consent[data-required="true"]');
      requiredConsents.forEach((consent) => {
        const checkbox = consent.querySelector('.violex-giveaway__email-gate-consent-checkbox');
        const checked = !!(checkbox && checkbox.checked);
        consent.classList.toggle('has-error', !checked);
        if (!checked) {
          shakeGateEl(consent);
          ok = false;
        }
      });

      if (!ok) return;

      // Schloss-Oeffnen-Animation abspielen (siehe .is-unlocking in
      // violex-giveaway.css), erst danach Gate ausblenden/Rad aufwecken.
      if (stageEl) stageEl.classList.add('is-unlocking');

      window.setTimeout(() => {
        if (stageEl) stageEl.classList.remove('is-unlocking');

        // E-Mail sofort lokal merken und Rad freigeben.
        setUnlockedEmail(email);
        refreshGateVisibility();
      }, 620);

      // Kundenformular per fetch() im Hintergrund abschicken statt per
      // echtem form.submit(): ein echter Submit wuerde die Seite verlassen
      // (Shopifys eigener Bot-Schutz leitet dabei oft zusaetzlich auf eine
      // Zwischenseite /challenge um, siehe bekanntes Verhalten in CLAUDE.md) -
      // hier wollen wir aber genau auf der Giveaway-Seite bleiben, damit
      // sofort gedreht werden kann. mode: "no-cors" heisst, wir koennen die
      // Antwort nicht auslesen (kein Fehler sichtbar, falls es fehlschlaegt),
      // aber das ist ein bewusster Kompromiss - die E-Mail-Freischaltung
      // selbst haengt nicht davon ab, nur das Anlegen als Shopify-Kunde.

      // Tag an die Marketing-Einwilligung koppeln (26.08.2026). "drop-list"
      // wird NUR vergeben, wenn die freiwillige Checkbox angehakt ist.
      //
      // Ohne das waere die Checkbox reine Deko: die Release-/Drop-Mail im
      // Worker sucht ihre Empfaenger allein ueber den Tag
      // (violex-elite-api/src/releaseMail.js, DROP_LIST_QUERY = "tag:'drop-list'
      // OR tag:'backup-plan-2026'") und wertet accepts_marketing nirgends aus.
      // Frueher stand "drop-list" fest im Formular - jeder Teilnehmer landete
      // also im Werbeverteiler, egal was er angekreuzt hat.
      //
      // "giveaway-2026" bekommt jeder: reine Teilnahme-Dokumentation (Nachweis,
      // dass Alters-/Wohnsitz- und Teilnahmebedingungen-Box bestaetigt wurden -
      // beide sind Pflichtfelder, ohne sie kommt das Formular nicht durch).
      const tagsField = document.getElementById('GiveawayEmailGateTags');
      const marketingBox = document.getElementById('GiveawayEmailGateMarketing');
      if (tagsField) {
        tagsField.value = marketingBox && marketingBox.checked
          ? 'giveaway-2026, drop-list'
          : 'giveaway-2026';
      }

      try {
        fetch(emailGateForm.action, {
          method: 'POST',
          mode: 'no-cors',
          body: new FormData(emailGateForm),
        }).catch(() => {});
      } catch (e) {
        // s.o. - stiller Fallback.
      }
    });
  }

  wheelWrap.addEventListener('click', () => {
    if (!getUnlockedEmail()) {
      if (emailGateInput) emailGateInput.focus();
      return;
    }
    spin();
  });
  wheelWrap.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (!getUnlockedEmail()) {
        if (emailGateInput) emailGateInput.focus();
        return;
      }
      spin();
    }
  });

  if (celebration) {
    celebration.addEventListener('click', () => {
      if (celebrationTimeout) {
        window.clearTimeout(celebrationTimeout);
        celebrationTimeout = null;
      }
      celebration.classList.remove('is-visible');
      celebration.setAttribute('aria-hidden', 'true');
      const celebrationTextEl = celebration.querySelector('.violex-giveaway__celebration-text');
      if (celebrationTextEl) celebrationTextEl.classList.remove('is-shown');
    });
  }

  // Vollbild-Popup fuer Tueren/Portemonnaie (Tueren-Redesign 2026-08-26) -
  // Bild + Titel kommen aus data-reveal-image/-title des angeklickten
  // Triggers, siehe violex-giveaway.liquid.
  const revealEl = document.getElementById('GiveawayReveal');
  const revealTitleEl = document.getElementById('GiveawayRevealTitle');
  const revealImageEl = document.getElementById('GiveawayRevealImage');
  const revealCloseBtn = document.getElementById('GiveawayRevealClose');

  if (revealEl) {
    const openReveal = (title, image, variant) => {
      if (revealTitleEl) revealTitleEl.textContent = title || '';
      if (revealImageEl) {
        revealImageEl.src = image || '';
        revealImageEl.alt = title || '';
      }
      revealEl.classList.toggle('violex-giveaway__reveal--fullscreen', variant === 'fullscreen');
      revealEl.classList.add('is-open');
      revealEl.setAttribute('aria-hidden', 'false');
      lockScroll();
    };
    const allTriggers = document.querySelectorAll('[data-reveal-trigger]');
    const closeReveal = () => {
      // Frueh raus, wenn ohnehin schon zu - sonst wuerde ein zweiter
      // Schliess-Auslöser (X-Klick, der zusaetzlich auf dem Overlay landet)
      // den Zaehler in lockScroll/unlockScroll aus dem Tritt bringen.
      if (!revealEl.classList.contains('is-open')) return;
      revealEl.classList.remove('is-open');
      revealEl.setAttribute('aria-hidden', 'true');
      unlockScroll();
      // Tueren wieder in den leisen Pulsier-Zustand zuruecksetzen, bereit
      // fuer die naechste Oeffnen-Animation.
      allTriggers.forEach((t) => t.classList.remove('is-opening'));
    };
    // Vorgabe Igor, 2026-08-26: "Animationen bei Tuer/Portemonnaie entfernen,
    // nur noch groesser/kleiner pulsieren, Tueren beim Klicken zuerst langsam
    // oeffnen" - der fruehere Zoom-in-Schwarz-Dive danach (.is-diving) ist
    // komplett weg, das Popup erscheint direkt im Anschluss. Das Portemonnaie
    // hat als flaches Objekt gar keine "Oeffnen"-Geste mehr und zeigt das
    // Popup sofort.
    const DOOR_OPEN_MS = 1400;
    allTriggers.forEach((trigger) => {
      const isDoor = trigger.classList.contains('violex-giveaway__door');
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('is-opening')) return;
        const open = () => openReveal(trigger.getAttribute('data-reveal-title'), trigger.getAttribute('data-reveal-image'), trigger.getAttribute('data-reveal-variant'));
        if (!isDoor) {
          open();
          return;
        }
        trigger.classList.add('is-opening');
        window.setTimeout(open, DOOR_OPEN_MS);
      });
    });
    if (revealCloseBtn) revealCloseBtn.addEventListener('click', closeReveal);
    revealEl.addEventListener('click', (event) => {
      if (event.target === revealEl) closeReveal();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && revealEl.classList.contains('is-open')) closeReveal();
    });
  }

  // Optionaler Bot-Schutz (Cloudflare Turnstile) - nur aktiv, wenn im Section-
  // Setting ein Site-Key hinterlegt ist (turnstile_site_key). Ohne Site-Key
  // bleibt turnstileToken dauerhaft null, requestSpin() schickt dann einfach
  // kein Token mit - der Worker verlangt es nur, wenn er selbst ein
  // TURNSTILE_SECRET_KEY konfiguriert hat (siehe giveawaySpin.js).
  function resetTurnstile() {
    turnstileToken = null;
    if (window.turnstile && turnstileWidgetId !== null) {
      try {
        window.turnstile.reset(turnstileWidgetId);
      } catch (e) {
        // Widget evtl. noch nicht bereit - beim naechsten Spin-Versuch ist
        // ohnehin ein frischer Render-Zyklus faellig.
      }
    }
  }

  function initTurnstile() {
    if (!turnstileEl || !turnstileSiteKey || !window.turnstile) return;
    turnstileWidgetId = window.turnstile.render(turnstileEl, {
      sitekey: turnstileSiteKey,
      size: 'invisible',
      callback: (token) => {
        turnstileToken = token;
      },
    });
  }

  if (turnstileSiteKey) {
    if (window.turnstile) {
      initTurnstile();
    } else {
      // Das Turnstile-Skript laedt async (siehe violex-giveaway.liquid) und
      // ruft diesen globalen Callback selbst auf, sobald es bereit ist -
      // robust unabhaengig davon, welches der beiden Skripte zuerst fertig
      // laedt.
      window.violexTurnstileOnLoad = initTurnstile;
    }
  }
});
